import { useState } from 'react';

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);

  const faqs = [
    {
      question: 'Сколько времени ждать ответа?',
      answer: 'Обычно отвечаем в течение одного рабочего дня. В срочных случаях — в течение нескольких часов. Все заявки обрабатываются лично, без автоответчиков и шаблонных сообщений.'
    },
    {
      question: 'Можно ли провести предварительную встречу?',
      answer: 'Да, перед началом любого проекта мы проводим онлайн- или офлайн-встречу. Это нужно для понимания задач бизнеса, анализа текущей ситуации и определения целей обучения. Предварительная встреча ни к чему не обязывает.'
    },
    {
      question: 'Можно ли провести обучение в другом городе?',
      answer: 'Да, мы работаем по всей Беларуси. Также проводим проекты в России, Казахстане, Узбекистане, Израиле. Многие программы успешно проходят онлайн — эффективность не уступает очному формату.'
    },
    {
      question: 'Можно ли заказать только консультацию?',
      answer: 'Да, если сначала необходимо обсудить задачу — можно провести консультацию без обязательства заказывать обучение. Это поможет понять масштаб проблемы, возможные пути решения и определиться с дальнейшими шагами.'
    },
    {
      question: 'Можно ли провести обучение онлайн?',
      answer: 'Да, многие программы успешно проходят полностью дистанционно. Онлайн-формат включает интерактивные инструменты, разбор реальных кейсов, ролевые игры и практические задания. При правильной организации эффективность онлайн-обучения не уступает очному.'
    },
    {
      question: 'Как быстро готовится программа после обращения?',
      answer: 'После первичной консультации и диагностики индивидуальная программа готовится в течение 3-7 рабочих дней в зависимости от сложности проекта и количества участников. Мы не используем шаблоны — каждая программа создаётся под конкретный бизнес.'
    },
    {
      question: 'Сколько длится корпоративное обучение?',
      answer: 'Форматы варьируются: интенсивный тренинг — 1-2 полных дня, модульная программа — от 2 недель до 3 месяцев, комплексная программа с сопровождением — 3-12 месяцев. Точная продолжительность определяется после диагностики и зависит от поставленных бизнес-целей.'
    },
    {
      question: 'Какие компании к вам обращаются?',
      answer: 'Мы работаем с компаниями из B2B и B2C секторов: логистика, IT, недвижимость, производство, финансовые услуги, медицина, строительство, образование и EdTech, розничная торговля, сфера услуг. Программы адаптируются под специфику отрасли и размер компании.'
    }
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на вопросы, которые чаще всего задают перед первым обращением.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  {openFaq === index ? (
                    <i className="ri-arrow-up-s-line text-teal-600"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-teal-600"></i>
                  )}
                </div>
              </button>
              <div className={`px-6 pb-6 ${openFaq === index ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}